export function getQueryParam(name: string): string | null {
    return new URL(window.location.href).searchParams.get(name);
}

export function pathnameContains(segment: string): boolean {
    return window.location.pathname.includes(segment);
}
